import { render, staticRenderFns } from "./AtencionExamenes.vue?vue&type=template&id=604ea8a1"
import script from "./AtencionExamenes.vue?vue&type=script&lang=js"
export * from "./AtencionExamenes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports